import Vue from 'vue'
import ShowDoctorInfo from './index.vue'

Vue.component('ShowDoctorInfo', ShowDoctorInfo)



// WEBPACK FOOTER //
// ./src/components/showDoctorInfo/load.js